// extracted by mini-css-extract-plugin
module.exports = {"tile":"CompanyTile_tile__28a45","media":"CompanyTile_media__cCSxB","content":"CompanyTile_content__byZmQ"};